import { LoadingStatusCode } from "../types/LoadingStatusCode";

interface LoadingStatusCodes {
  pending: LoadingStatusCode;
  fulfilled: LoadingStatusCode;
  rejected: LoadingStatusCode;
  idle: LoadingStatusCode;
}

const loadingStatusCodes: LoadingStatusCodes = {
  pending: "pending",
  fulfilled: "fulfilled",
  rejected: "rejected",
  idle: "idle",
};

export default loadingStatusCodes;
